(() => {
  const moneyFormat = window.theme?.moneyFormat || "${{amount}}";

  const formatMoney = (cents) => {
    const value = (Number(cents) / 100).toFixed(2);
    if (moneyFormat.includes("{{amount_no_decimals}}")) {
      return moneyFormat.replace("{{amount_no_decimals}}", String(Math.round(Number(cents) / 100)));
    }
    return moneyFormat.replace("{{amount}}", value).replace("{{amount_with_comma_separator}}", value.replace(".", ","));
  };

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const setCartCount = (count) => {
    qsa("[data-cart-count]").forEach((el) => {
      el.textContent = String(count);
      el.hidden = Number(count) === 0;
    });
  };

  const fetchCart = () => fetch(window.theme.routes.cartJs).then((r) => r.json());

  const initMenu = () => {
    const drawer = qs("[data-menu-drawer]");
    if (!drawer) return;
    const open = () => {
      drawer.classList.add("is-open");
      document.body.style.overflow = "hidden";
      qs("[data-menu-close]", drawer)?.focus();
    };
    const close = () => {
      drawer.classList.remove("is-open");
      document.body.style.overflow = "";
    };
    qsa("[data-menu-open]").forEach((btn) => btn.addEventListener("click", open));
    qsa("[data-menu-close]", drawer).forEach((btn) => btn.addEventListener("click", close));
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });
  };

  const initAgeGate = () => {
    const gate = qs("[data-age-gate]");
    if (!gate) return;
    if (localStorage.getItem("tobatac-age-ok") === "1") return;
    gate.classList.add("is-open");
    document.body.style.overflow = "hidden";
    qs("[data-age-confirm]", gate)?.addEventListener("click", () => {
      localStorage.setItem("tobatac-age-ok", "1");
      gate.classList.remove("is-open");
      document.body.style.overflow = "";
    });
  };

  const renderAddedModal = (item, cart) => {
    const modal = qs("[data-added-modal]");
    if (!modal) return;
    qs("[data-added-title]", modal).textContent = item.product_title || item.title;
    qs("[data-added-price]", modal).textContent = formatMoney(item.final_price ?? item.price);
    const img = qs("[data-added-image]", modal);
    if (img) {
      img.src = item.image || "";
      img.alt = item.product_title || item.title || "";
    }
    const options = qs("[data-added-options]", modal);
    if (options) {
      const parts = (item.options_with_values || [])
        .filter((o) => o.value && o.value !== "Default Title")
        .map((o) => o.value);
      if (item.selling_plan_allocation?.selling_plan?.name) {
        parts.push(item.selling_plan_allocation.selling_plan.name);
      }
      options.innerHTML = parts.map((p) => `<p class="modal-meta">${p}</p>`).join("");
    }
    const view = qs("[data-added-view]", modal);
    if (view) view.textContent = `VIEW CART (${cart.item_count})`;
    modal.classList.add("is-open");
  };

  const initAddedModal = () => {
    const modal = qs("[data-added-modal]");
    if (!modal) return;
    qsa("[data-added-close]", modal).forEach((btn) => {
      btn.addEventListener("click", () => modal.classList.remove("is-open"));
    });
  };

  const initProductForm = () => {
    qsa("[data-product-form]").forEach((form) => {
      const idInput = qs("[name='id']", form);
      const jsonEl = qs("[data-product-json]", form) || qs("[data-product-json]");
      const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      const priceEl = qs("[data-product-price]");
      const optionInputs = qsa("[data-option-input]", form);
      const sellingInputs = qsa("[name='selling_plan'][type='radio']", form);
      const clubPlans = qsa("[data-club-plan]", form);
      const sellingPlanInput = qs("[data-selling-plan-input]", form);

      const selectedOptions = () => optionInputs.map((input) => input.value);

      const findVariant = () => {
        const values = selectedOptions();
        if (!values.length) return variants[0];
        return variants.find((v) => v.options.every((opt, i) => opt === values[i])) || variants[0];
      };

      const sync = () => {
        const variant = findVariant();
        if (!variant || !idInput) return;
        idInput.value = variant.id;
        if (priceEl && !sellingInputs.length) {
          priceEl.textContent = formatMoney(variant.price);
        }
        const addBtn = qs("[name='add']", form);
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available
            ? addBtn.dataset.addLabel || "Add to cart"
            : addBtn.dataset.soldOut || "Sold out";
        }
        qsa("[data-buy-now]", form).forEach((el) => {
          el.hidden = !variant.available;
        });
      };

      optionInputs.forEach((input) => input.addEventListener("change", sync));
      sellingInputs.forEach((input) => {
        input.addEventListener("change", () => {
          sellingInputs.forEach((row) => {
            row.closest("[data-plan-row]")?.classList.toggle("is-active", row.checked);
          });
          const checked = sellingInputs.find((i) => i.checked);
          const amount = checked?.dataset.price;
          if (priceEl && amount) priceEl.textContent = formatMoney(amount);
        });
      });
      const applyClubPlan = (input) => {
        if (!input) return;
        if (idInput && input.dataset.variantId) idInput.value = input.dataset.variantId;
        if (sellingPlanInput) sellingPlanInput.value = input.dataset.sellingPlan || "";
        clubPlans.forEach((row) => {
          row.closest("[data-plan-row]")?.classList.toggle("is-active", row.checked);
        });
        if (priceEl && input.dataset.price) priceEl.textContent = formatMoney(input.dataset.price);

        const available = input.dataset.available !== "false";
        const qtyEl = qs("[data-club-qty]", form);
        const guarantee = qs("[data-guarantee-list]", form) || qs("[data-guarantee-list]");
        if (qtyEl) qtyEl.hidden = !available;
        if (guarantee) guarantee.hidden = available;
        qsa("[data-buy-now]", form).forEach((el) => {
          el.hidden = !available;
        });
        qsa("[name='add']", form).forEach((btn) => {
          if (btn.hasAttribute("data-buy-now") || btn.classList.contains("btn-checkout")) {
            btn.hidden = !available;
            btn.disabled = !available;
            return;
          }
          btn.disabled = !available;
          if (btn.classList.contains("btn-outline")) {
            btn.textContent = available
              ? btn.dataset.addLabel || "ADD TO CART"
              : btn.dataset.soldOut || "Sold out";
          }
        });
      };
      clubPlans.forEach((input) => input.addEventListener("change", () => applyClubPlan(input)));
      if (clubPlans.length) applyClubPlan(clubPlans.find((i) => i.checked) || clubPlans[0]);
      else sync();

      form.addEventListener("submit", async (event) => {
        if (form.dataset.noAjax === "true") return;
        event.preventDefault();
        const data = new FormData(form);
        const res = await fetch(window.theme.routes.cartAdd + ".js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: data,
        });
        if (!res.ok) return;
        const item = await res.json();
        const cart = await fetchCart();
        setCartCount(cart.item_count);
        renderAddedModal(item, cart);
      });
    });
  };

  const initQuantity = () => {
    qsa("[data-qty]").forEach((wrap) => {
      const input = qs("input", wrap);
      qsa("[data-qty-btn]", wrap).forEach((btn) => {
        btn.addEventListener("click", () => {
          const next = Number(input.value || 1) + Number(btn.dataset.qtyBtn);
          input.value = Math.max(1, next);
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  };

  const initCartPage = () => {
    qsa("[data-cart-qty]").forEach((input) => {
      input.addEventListener("change", async () => {
        await fetch(window.theme.routes.cartChange + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ line: Number(input.dataset.line), quantity: Number(input.value) }),
        });
        window.location.reload();
      });
    });
    qsa("[data-cart-remove]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        await fetch(window.theme.routes.cartChange + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ line: Number(btn.dataset.line), quantity: 0 }),
        });
        window.location.reload();
      });
    });
  };

  const initCollectionSort = () => {
    const select = qs("[data-sort-select]");
    if (!select) return;
    select.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", select.value);
      window.location.href = url.toString();
    });
  };

  const initAccordions = () => {
    qsa("[data-accordion-toggle]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const open = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!open));
        const panel = document.getElementById(btn.getAttribute("aria-controls"));
        if (panel) panel.hidden = open;
      });
    });
  };

  const initShare = () => {
    qsa("[data-share]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        const url = window.location.href;
        if (navigator.share) {
          try {
            await navigator.share({ title: document.title, url });
          } catch (e) {
            /* cancelled */
          }
        } else if (navigator.clipboard) {
          await navigator.clipboard.writeText(url);
          btn.textContent = "Copied";
        }
      });
    });
  };

  const initReviewForm = () => {
    const dialog = document.querySelector("[data-review-dialog]");
    const openBtn = document.querySelector("[data-review-write]");
    const closeBtn = document.querySelector("[data-review-close]");
    const form = document.querySelector(".review-form");
    if (openBtn && dialog) {
      openBtn.addEventListener("click", () => dialog.showModal());
    }
    if (closeBtn && dialog) {
      closeBtn.addEventListener("click", () => dialog.close());
    }
    if (dialog) {
      dialog.addEventListener("click", (event) => {
        if (event.target === dialog) dialog.close();
      });
    }
    qsa("[data-review-star]").forEach((star) => {
      star.addEventListener("click", () => {
        const value = Number(star.getAttribute("data-review-star"));
        const input = document.querySelector("[data-review-rating]");
        if (input) input.value = String(value);
        qsa("[data-review-star]").forEach((other) => {
          const n = Number(other.getAttribute("data-review-star"));
          other.setAttribute("aria-pressed", n <= value ? "true" : "false");
        });
      });
    });
    if (form) {
      form.addEventListener("submit", () => {
        const rating = document.querySelector("[data-review-rating]")?.value || "5";
        const title = (document.querySelector("[data-review-title]")?.value || "").replace(/\|/g, " ");
        const body = form.querySelector("[data-review-body]");
        if (body) body.value = `${rating}|${title}\n${body.value.trim()}`;
      });
    }
  };

  const initPredictiveSearch = () => {
    const root = qs("[data-predictive-search]");
    if (!root) return;

    const input = qs("[data-search-input]", root);
    const results = qs("[data-search-results]", root);
    const status = qs("[data-search-status]", root);
    const viewAll = qs("[data-search-view-all]", root);
    const minChars = Number(root.dataset.minChars || 4);
    const searchUrl = root.dataset.searchUrl || window.theme?.routes?.search || "/search";
    const predictiveUrl =
      window.theme?.routes?.predictiveSearch || "/search/suggest.json";
    const messages = {
      typeMore: root.dataset.msgTypeMore || "Type at least 4 characters",
      searching: root.dataset.msgSearching || "Searching…",
      noResults: root.dataset.msgNoResults || "No products found",
      viewAll: root.dataset.msgViewAll || "View all results",
    };

    let debounceTimer = null;
    let abortController = null;
    let lastFocused = null;

    const setStatus = (text, show = true) => {
      if (!status) return;
      status.textContent = text || "";
      status.hidden = !show || !text;
    };

    const closeMenuIfOpen = () => {
      const drawer = qs("[data-menu-drawer]");
      if (drawer?.classList.contains("is-open")) {
        drawer.classList.remove("is-open");
      }
    };

    const open = () => {
      lastFocused = document.activeElement;
      closeMenuIfOpen();
      root.hidden = false;
      root.classList.add("is-open");
      document.body.style.overflow = "hidden";
      requestAnimationFrame(() => input?.focus());
      const q = (input?.value || "").trim();
      if (q.length < minChars) {
        results.innerHTML = "";
        if (viewAll) viewAll.hidden = true;
        setStatus(messages.typeMore);
      }
    };

    const close = () => {
      root.classList.remove("is-open");
      root.hidden = true;
      document.body.style.overflow = "";
      if (abortController) abortController.abort();
      if (lastFocused && typeof lastFocused.focus === "function") {
        lastFocused.focus();
      }
    };

    const escapeHtml = (value) =>
      String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

    const productPrice = (product) => {
      const raw = product.price ?? product.price_min;
      if (raw == null || raw === "") return "";
      const asNumber = Number(raw);
      if (!Number.isFinite(asNumber)) return String(raw);
      // Predictive API usually returns decimal strings like "19.99"
      if (String(raw).includes(".") || asNumber < 1000) {
        return formatMoney(Math.round(asNumber * 100));
      }
      return formatMoney(asNumber);
    };

    const productImage = (product) => {
      const featured = product.featured_image;
      if (typeof featured === "string") return featured;
      if (featured?.url) return featured.url;
      if (product.image) return product.image;
      return "";
    };

    const renderProducts = (products, query) => {
      if (!products.length) {
        results.innerHTML = "";
        setStatus(messages.noResults);
        if (viewAll) {
          viewAll.hidden = false;
          viewAll.href = `${searchUrl}?q=${encodeURIComponent(query)}&type=product`;
        }
        return;
      }

      setStatus("");
      results.innerHTML = products
        .map((product) => {
          const title = escapeHtml(product.title || "");
          const url = escapeHtml(product.url || "#");
          const price = escapeHtml(productPrice(product));
          const image = escapeHtml(productImage(product));
          const thumb = image
            ? `<img class="predictive-search__thumb" src="${image}" alt="" width="72" height="72" loading="lazy">`
            : `<span class="predictive-search__thumb predictive-search__thumb--empty" aria-hidden="true"></span>`;
          return `<a class="predictive-search__item" role="option" href="${url}">
            ${thumb}
            <p class="predictive-search__title">${title}</p>
            <p class="predictive-search__price">${price}</p>
          </a>`;
        })
        .join("");

      if (viewAll) {
        viewAll.hidden = false;
        viewAll.href = `${searchUrl}?q=${encodeURIComponent(query)}&type=product`;
        viewAll.textContent = messages.viewAll;
      }
    };

    const runSearch = (query) => {
      if (abortController) abortController.abort();
      abortController = new AbortController();
      setStatus(messages.searching);
      const params = new URLSearchParams({
        q: query,
        "resources[type]": "product",
        "resources[limit]": "8",
        "resources[options][unavailable_products]": "last",
        "resources[options][fields]": "title,product_type,variants.title,vendor",
      });

      fetch(`${predictiveUrl}?${params.toString()}`, {
        signal: abortController.signal,
        headers: { Accept: "application/json" },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Search failed");
          return res.json();
        })
        .then((data) => {
          const products = data?.resources?.results?.products || [];
          renderProducts(products, query);
        })
        .catch((err) => {
          if (err.name === "AbortError") return;
          results.innerHTML = "";
          setStatus(messages.noResults);
          if (viewAll) viewAll.hidden = true;
        });
    };

    const onInput = () => {
      const query = (input?.value || "").trim();
      clearTimeout(debounceTimer);
      if (query.length < minChars) {
        if (abortController) abortController.abort();
        results.innerHTML = "";
        if (viewAll) viewAll.hidden = true;
        setStatus(query.length ? messages.typeMore : messages.typeMore);
        return;
      }
      debounceTimer = setTimeout(() => runSearch(query), 280);
    };

    qsa("[data-search-open]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        open();
      });
    });
    qsa("[data-search-close]", root).forEach((btn) => {
      btn.addEventListener("click", close);
    });
    input?.addEventListener("input", onInput);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && root.classList.contains("is-open")) {
        e.preventDefault();
        close();
      }
    });
  };

  const initBlogFilter = () => {
    const root = qs("[data-blog-index]");
    if (!root) return;

    const input = qs("[data-blog-query]", root);
    const grid = qs("[data-blog-grid]", root);
    const cards = qsa("[data-blog-card]", root);
    const empty = qs("[data-blog-empty]", root);
    const emptyTerm = qs("[data-blog-empty-term]", root);
    const pagination = qs("[data-blog-pagination]", root);
    if (!input || !cards.length) return;

    let debounceTimer = null;
    let settleTimer = null;

    const setSearching = (on) => {
      root.classList.toggle("is-searching", on);
      input.setAttribute("aria-busy", on ? "true" : "false");
    };

    const applyFilter = () => {
      const query = input.value.trim().toLowerCase();
      let shown = 0;
      let visibleIndex = 0;

      cards.forEach((card) => {
        const haystack = [
          card.getAttribute("data-blog-search") || "",
          (card.querySelector("h2")?.textContent || ""),
        ]
          .join(" ")
          .toLowerCase();
        const match = !query || haystack.includes(query);
        card.toggleAttribute("hidden", !match);
        card.style.removeProperty("--blog-stagger");
        if (match) {
          card.style.setProperty("--blog-stagger", `${visibleIndex * 40}ms`);
          visibleIndex += 1;
          shown += 1;
        }
      });

      if (empty) {
        empty.hidden = shown > 0;
        if (emptyTerm) emptyTerm.textContent = input.value.trim();
      }
      if (pagination) pagination.hidden = Boolean(query);

      if (grid) {
        grid.classList.remove("is-filtering");
        // Force reflow so the enter animation restarts
        void grid.offsetWidth;
        grid.classList.add("is-revealing");
      }

      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(() => {
        setSearching(false);
        grid?.classList.remove("is-revealing");
      }, Math.min(420, 180 + visibleIndex * 40));
    };

    const onInput = () => {
      setSearching(true);
      grid?.classList.add("is-filtering");
      grid?.classList.remove("is-revealing");
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(applyFilter, 220);
    };

    input.addEventListener("input", onInput);
  };

  document.addEventListener("DOMContentLoaded", () => {
    initMenu();
    initAgeGate();
    initAddedModal();
    initPredictiveSearch();
    initProductForm();
    initQuantity();
    initCartPage();
    initCollectionSort();
    initAccordions();
    initShare();
    initReviewForm();
    initBlogFilter();
    setCartCount(window.theme?.cartCount || 0);
  });
})();
